export function SchedulingSettingsPage() {
  return (
    <div className="space-y-6">
      <div className="text-center lg:text-left">
        <h2 className="text-xl lg:text-2xl font-bold text-foreground mb-2">Time Slots</h2>
        <p className="text-muted-foreground text-sm lg:text-base">
          Configure booking intervals and timing rules
        </p>
      </div>
      <div className="text-center py-12">
        <p className="text-muted-foreground">Scheduling settings coming soon</p>
      </div>
    </div>
  );
}
